export default __webpack_public_path__ + "static/illo-view-dashboard-ef9ca7dc25d98be5128380e1f39f5708.svg";